import moment from 'moment'

import { FIELD_BIND_TYPE_ENUM } from '@constants'
import { CommandParameterDTO, FormRow, ObjectDataRecord } from '@types'

import { executeCode } from './executeCode'

export interface ExecutionContext {
  outerSrcObj?: ObjectDataRecord
  formValues?: Record<string, any>
  enrichedObject?: ObjectDataRecord

  [key: string]: any
}

export const getCommandRequestData = (
  commandParameters: CommandParameterDTO[],
  srcObj?: ObjectDataRecord | null,
  srcObjByCodes?: boolean,
  fieldsFormConfig?: FormRow[],
  executionContext?: ExecutionContext
) => {
  return commandParameters.reduce((acc: Record<string, string | number>, item) => {
    switch (item.type) {
      case FIELD_BIND_TYPE_ENUM.JS: {
        acc[item.title] = executeCode(item.value, {
          ...(executionContext || {}),
          srcObj: srcObj || {},
          moment,
        }) as string
        break
      }
      case FIELD_BIND_TYPE_ENUM.FIELD: {
        if (srcObjByCodes) {
          const objectCode = item.pathArray?.[0]?.objectCode
          acc[item.title] = objectCode ? srcObj?.[objectCode]?.[item.value] ?? '' : ''
          break
        }

        if (fieldsFormConfig) {
          const codeSoughtField =
            fieldsFormConfig.find(field => {
              return field.value === item.value
            })?.code ?? ''

          acc[item.title] = srcObj?.[codeSoughtField]

          break
        }

        acc[item.title] = srcObj?.[item.value] ?? ''
        break
      }
      case FIELD_BIND_TYPE_ENUM.STATIC: {
        acc[item.title] = item.value
        break
      }
      default:
        acc[item.title] = item.value
    }

    return acc
  }, {})
}
